import axios from 'axios';
import { Building } from '../interfaces/api/building';

export interface BuildingSearchFilterParam {
	search?: string;
	organization?: string;
}

function queryBuilderSearchFilter(params: BuildingSearchFilterParam): URLSearchParams {
	const queryParams = new URLSearchParams();
	if (params.search) {
		queryParams.append('search', params.search);
	}
	if (params.organization) {
		queryParams.append('organization', params.organization);
	}
	return queryParams;
}

export async function getBuildings(): Promise<Building[]> {
	try {
		const response = await axios.get<Building[]>('api/buildings/');
		return response.data;
	} catch (error) {
		if (axios.isAxiosError(error)) {
			throw error.response;
		}
		throw error;
	}
}

export async function getBuilding(id: number): Promise<Building> {
	try {
		const response = await axios.get<Building>(`api/buildings/${id}/`);
		return response.data;
	} catch (error) {
		if (axios.isAxiosError(error)) {
			throw error.response;
		}
		throw error;
	}
}

export async function getBuildingSearchFilter(
	params: BuildingSearchFilterParam
): Promise<Building[]> {
	try {
		const queryParams = queryBuilderSearchFilter(params);
		const response = await axios.get<Building[]>(`api/buildings/`, {
			params: queryParams,
		});
		return response.data;
	} catch (error) {
		if (axios.isAxiosError(error)) {
			throw error.response;
		}
		throw error;
	}
}
